import React, { useEffect, useState } from 'react';
import Reports from '../features/Dashboard/components/reports';
import Figures from '../features/Dashboard/components/figures';
import RecentTransactions from '../features/Dashboard/components/recent_transactions';
import OverviewAnalytics from '../features/Dashboard/components/overview_analytics';
import { useSubscriptionsStore } from '../features/Subscriptions/store/subscriptions';
import { getGatewayStatsSummary, usePaymentsStore } from '../features/Payments/store/paymentsStore';
import { usePackagesStore } from '../features/Packages/store/packagesStore';
import { getMingoliUsers } from '../features/Users/services/services';
import { useUserStore } from '../features/Users/store/userStore';
import { PuffLoader } from 'react-spinners';
import { RecentTransactionsSkeleton } from '../features/Dashboard/components/recent_transactions_skeleton';

const OverviewContent: React.FC = () => {
    // Users
    const { users, newUsers, fetchUsers } = useUserStore();

    const { stats, fetchSubscriptions } = useSubscriptionsStore();


    // Packages
    const { packages, fetchAllPackages, error } = usePackagesStore();
    // const [loading, setLoading] = useState(true);

    // Payments
    const {payments, fetchPayments} = usePaymentsStore();
    const gatewayStats = usePaymentsStore(state => state.gatewayStats);
    const gatewayStatsSummary = getGatewayStatsSummary(gatewayStats);

    // Loading
    const [loading, setLoading] = useState({
        users: true,
        subscriptions: true,
        packages: true,
        payments: true,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const promises: Promise<any>[] = [];

                if (users.length === 0) {
                    promises.push(
                        fetchUsers().finally(() =>
                            setLoading(prev => ({ ...prev, users: false }))
                        )
                    );
                } else {
                    setLoading(prev => ({ ...prev, users: false }));
                }

                if (!stats) {
                    promises.push(
                        fetchSubscriptions().finally(() =>
                            setLoading(prev => ({ ...prev, subscriptions: false }))
                        )
                    );
                } else {
                    setLoading(prev => ({ ...prev, subscriptions: false }));
                }

                if (packages.length === 0) {
                    promises.push(
                        fetchAllPackages().finally(() =>
                            setLoading(prev => ({ ...prev, packages: false }))
                        )
                    );
                } else {
                    setLoading(prev => ({ ...prev, packages: false }));
                }

                if (payments.length === 0) {
                    promises.push(
                        fetchPayments().finally(() =>
                            setLoading(prev => ({ ...prev, payments: false }))
                        )
                    );
                } else {
                    setLoading(prev => ({ ...prev, payments: false }));
                }

                if (promises.length > 0) {
                    await Promise.allSettled(promises);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [users.length, stats, packages.length, gatewayStats.length, fetchPayments, fetchSubscriptions, fetchAllPackages, fetchUsers]);

    return (
        <div className='py-4'>
            <Reports />
            <Figures
                users={users.length}
                newUsers={newUsers.length}
                packages={packages.length}
                revenue={stats?.totalRevenue || 0}
                activeSubscribers={stats?.activeSubscribers || 0}
                loadingUsers={loading.users}
                loadingNewUsers={loading.users}
                loadingPackages={loading.packages}
                loadingRevenue={loading.subscriptions}
                loadingSubscribers={loading.subscriptions}
            />
            {loading.subscriptions ? (
                <RecentTransactionsSkeleton />
            ) : (
                <RecentTransactions subscriptions={stats?.recentSubscriptions || []} />
            )}

            <OverviewAnalytics gatewayStats={gatewayStatsSummary} />
        </div>
    );
};

export default OverviewContent;